import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { readBookingHandoff } from '../utils/bookingTab';

// Landing page for booking tabs opened from the results list.
// Waits for the results tab to hand over the booking state, then moves to the real page.
const WAIT_LIMIT_MS = 60000;
const POLL_MS = 150;

const BookingHandoff = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [failed, setFailed] = useState(false);
    const id = searchParams.get('h');

    useEffect(() => {
        let done = false;
        const started = Date.now();

        const finish = (payload) => {
            if (done) return;
            done = true;
            if (payload.cancel || !payload.path) {
                window.close(); // works because this tab was opened by script
                setFailed(true); // shown only if the browser refused to close it
                return;
            }
            navigate(payload.path, { state: payload.state, replace: true });
        };

        const check = () => {
            const payload = readBookingHandoff(id);
            if (payload) finish(payload);
            else if (Date.now() - started > WAIT_LIMIT_MS) {
                done = true;
                setFailed(true);
            }
        };

        check();
        const timer = setInterval(() => { if (!done) check(); else clearInterval(timer); }, POLL_MS);
        return () => { done = true; clearInterval(timer); };
    }, [id, navigate]);

    return (
        <div style={{
            minHeight: '100vh', display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center', gap: 16,
            fontFamily: 'inherit', color: '#0F172A', padding: 16, textAlign: 'center'
        }}>
            {failed ? (
                <>
                    <p style={{ fontSize: 18, fontWeight: 600, margin: 0 }}>We couldn't start this booking.</p>
                    <p style={{ margin: 0, color: '#64748B' }}>Please close this tab and try again from your search results.</p>
                    <button
                        onClick={() => navigate('/', { replace: true })}
                        style={{ background: '#FF4E01', color: '#fff', border: 0, borderRadius: 8, padding: '10px 20px', fontWeight: 600, cursor: 'pointer' }}
                    >
                        Go to Home
                    </button>
                </>
            ) : (
                <>
                    <div className="booking-handoff-spinner" style={{
                        width: 40, height: 40, borderRadius: '50%',
                        border: '4px solid #FFE4D6', borderTopColor: '#FF4E01',
                        animation: 'rcHandoffSpin 0.8s linear infinite'
                    }} />
                    <p style={{ fontSize: 16, fontWeight: 600, margin: 0 }}>Preparing your booking...</p>
                    <style>{'@keyframes rcHandoffSpin { to { transform: rotate(360deg); } }'}</style>
                </>
            )}
        </div>
    );
};

export default BookingHandoff;
